var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Cookies = OCS.Viewer.Cookies || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};

OCS.Viewer.Functions.get_storage_manager = function (ops) {
    if (!OCS.Live.StorageManager) {
        new OCS.Classes.StorageManager({
            expiration_offset: {
                local: 1 * 25 * 60 * 1000, // 20 minutes
                session: 1 * 25 * 60 * 1000, // 20 minutes,
                js: 1 * 75 * 60 * 1000, // 70 minutes
            }
        });
    }
    return OCS.Live.StorageManager;
};
OCS.Viewer.Functions.get_xmpp_device_name = function () {
    var ip = OCS.User_data.ip_address.split(".").join("-");
    var session_id = OCS.User_data.session_id;
    if (OCS.device) {
        if (OCS.device.forced) {
            if (OCS.device.desktop) {
                return "mobile";
            }
        } else {
            if (OCS.device.tablet) {
                return "tablet";
            }
            if (OCS.device.mobile) {
                return "mobile";
            }
        }
    }
    return "desktop:" + ip + ":" + session_id;
};
OCS.Viewer.Functions.get_event_manager = function (ops) {
    if (!OCS.Live.OCSEventManager) {
        new OCS.Classes.OCSEventManager(ops);
    }
    return OCS.Live.OCSEventManager;
};
OCS.Viewer.Functions.get_geometry_manager = function () {
    if (!OCS.Viewer.Live.GeometryManager) {
        OCS.Viewer.Live.GeometryManager = new OCS.Geometry.Classes.GeometryManager(OCS.Viewer.Config.geometry_manager_defaults);
    }
    return OCS.Viewer.Live.GeometryManager;
};

OCS.Viewer.Functions.get_cookie = function (name) {
    if (OCS.Viewer.Cookies.hasOwnProperty(name)) {
        return OCS.Viewer.Cookies[name];
    }

    if (name === 'session' && OCS.User && OCS.User.options && OCS.User.options.session_id) {
        // We have the cookie stored in the user object
        // Commenting this out, session_id is an incomplete portion of the cookie. - KDJ 2/23/18
        //return OCS.User.options.session_id;
    }

    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        // Cache the result for later use
        OCS.Viewer.Cookies[name] = parts.pop().split(";").shift();
        return OCS.Viewer.Cookies[name];
    }
};
OCS.Viewer.Functions.get_session_cookie = function () {
    return OCS.Viewer.Functions.get_cookie('session');
};

OCS.Viewer.Functions.get_dataworker_path = function () {
    var dataworker_path = 'dist/worker_deps.min.js';
    if (OCS.Viewer.Functions.use_workers()) {
        dataworker_path = 'workers/data_worker.min.js';
        if (OCS.Viewer.Config.use_shared_worker && OCS.Functions.is_shared_workers_supported()) {
            dataworker_path = 'workers/shared_data_worker.min.js';
        }
    }
    return dataworker_path;
};
OCS.Viewer.Functions.get_lightningworker_path = function () {
    var lightningworker_path = 'dist/worker_deps.min.js';
    if (OCS.Viewer.Functions.use_workers()) {
        lightningworker_path = 'workers/lightning_worker.min.js';
    }
    return lightningworker_path;
};

OCS.Viewer.Functions.use_workers = function () {
    return (OCS.Functions.is_ie()) ? false : OCS.Viewer.Config.use_workers;
};



/**
 * Method to make sure everything gets destroyed. This will destroy all instances of the interactive viewer, so use cautiously.
 * 
 */
OCS.Viewer.Functions.complete_destroy = function () {
    if (OCS.Viewer.Live) {
        var obj;
        // Destroy all the maps
        if (OCS.Viewer.Live.OCSMap) {
            Object.keys(OCS.Viewer.Live.OCSMap).each(function (key) {
                obj = OCS.Viewer.Live.OCSMap[key];
                if (obj && obj.destroy) {
                    obj.destroy();
                }
            });
            OCS.Viewer.Live.OCSMap = {};
        }

        Object.keys(OCS.Viewer.Live).each(function (key) {
            obj = OCS.Viewer.Live[key];
            if (obj && obj.destroy) {
                obj.destroy();
            }
        });
        OCS.Viewer.Live = {};

        // Kill storage
        if (OCS.Live.StorageManager) {
            OCS.Live.StorageManager.on_clear_storage();
            OCS.Live.StorageManager.destroy();
        }
    }

};

